
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
  onMounted,
  unref
} from 'vue'
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { createModel } from '@/utils/component'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import {
  getUserListForPage,
  createUser,
  updateUser,
  deleteUser,
  updateUserPassword, initializePassword
} from '@/apis/user'
import {
  getAllRoleNames
} from '@/apis/roles'
import {
  UserViewModel, UserPageParamModel, UserCreateModel, UserUpdateModel, UserUpdatePasswordModel
} from '@/model/userModel'
import { useI18n } from 'vue-i18n'
// import Pagination from '@/components/Pagination/index.vue'
export default defineComponent({
  name: 'Member',
  components: {
    SearchForm,
    Container
    // Pagination
  },
  setup() {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const searchStruct = [
      { prop: 'name', label: t('user.name'), component: 'el-input', type: 'text', model: '' },
      { prop: 'account', label: t('user.loginUser'), component: 'el-input', type: 'text', model: '' },
      { prop: 'department', label: t('user.department'), component: 'el-input', type: 'text', model: '' },
      {
        prop: 'active',
        label: t('dommonData.isActive'),
        component: 'el-select',
        model: true,
        options: [
          { label: t('dommonData.active'), value: true },
          { label: t('dommonData.notActive'), value: false }
        ]
      }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as any,
      tableKey: 0,
      list: Array<UserViewModel>(),
      total: 0,
      listLoading: true,
      page: 1,
      limit: 20,
      tempUserModel: {
        userId: null,
        userName: null,
        userRoleNames: [],
        userAccount: null,
        mailAddress: null,
        department: null,
        userPassword: null,
        passwordConfirm: null,
        active: true
      },
      roleNameOptions: Array<string>(),

      dialogFormVisible: false,
      dialogStatus: 'create',
      textMap: {
        update: 'user.edit',
        create: 'user.create',
        updatePassword: 'user.updatePassword'
      },
      passwordInitializedDialogVisible: false,
      // rules: {},
      async getRoleName() {
        const data = await getAllRoleNames()
        dataMap.roleNameOptions = data?.data ?? []
      },
      handleCurrentChange(page?: any) {
        dataMap.getList(page)
      },
      handleSizeChange(val: any) {
        dataMap.getList(null, val)
      },
      async getList(page?: any, limit?: any) {
        if (page) {
          dataMap.page = page
        }
        if (limit) {
          dataMap.limit = limit
        }

        dataMap.listLoading = true
        const params: UserPageParamModel = {
          userName: dataMap.searchFormModel.name,
          userRoleNames: null,
          userAccount: dataMap.searchFormModel.account,
          active: dataMap.searchFormModel.active,
          mailAddress: null,
          department: dataMap.searchFormModel.department,
          pageCurrent: dataMap.page,
          pageSize: dataMap.limit
        }

        const data = await getUserListForPage(params)
        dataMap.list = data?.data.list ?? []
        dataMap.total = data?.data.totalCount ?? 0

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      handleFilter() {
        dataMap.page = 1
        dataMap.getList()
      },
      handleCreate() {
        dataMap.dialogStatus = 'create'
        dataMap.dialogFormVisible = true
        nextTick(() => {
          (dataForm.value as typeof ElForm).resetFields()
          dataMap.tempUserModel.active = true
        })
      },
      createData() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const userCreateData: UserCreateModel = {
              userName: dataMap.tempUserModel.userName,
              userRoleNames: dataMap.tempUserModel.userRoleNames.join(','),
              userAccount: dataMap.tempUserModel.userAccount,
              mailAddress: dataMap.tempUserModel.mailAddress,
              department: dataMap.tempUserModel.department,
              userPassword: dataMap.tempUserModel.userPassword,
              active: dataMap.tempUserModel.active
            }
            const result = await createUser(userCreateData)
            if (result?.data && result?.data > 0) {
              ElMessage({
                message: t('user.createSuccessMessage'),
                type: 'success',
                duration: 2000
              })
              dataMap.dialogFormVisible = false
              await dataMap.getList()
            } else {
              ElMessage({
                message: result?.msg,
                type: 'error',
                duration: 2000
              })
            }
          }
        })
      },

      async handleUpdate(row: any) {
        dataMap.dialogStatus = 'update'
        dataMap.dialogFormVisible = true
        await nextTick(() => {
          (dataForm.value as typeof ElForm).resetFields()
        })
        dataMap.tempUserModel.userId = row.userId
        dataMap.tempUserModel.userName = row.userName
        dataMap.tempUserModel.userRoleNames = row.userRoleNames.split(',')
        dataMap.tempUserModel.mailAddress = row.mailAddress
        dataMap.tempUserModel.department = row.department
        dataMap.tempUserModel.active = row.active
      },
      updateData() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const userUpdateData: UserUpdateModel = {
              userId: dataMap.tempUserModel.userId,
              userName: dataMap.tempUserModel.userName,
              mailAddress: dataMap.tempUserModel.mailAddress,
              department: dataMap.tempUserModel.department,
              userRoleNames: dataMap.tempUserModel.userRoleNames.join(','),
              active: dataMap.tempUserModel.active
            }
            const result = await updateUser(userUpdateData)
            dataMap.dialogFormVisible = false
            dataMap.getList()
            if (result?.data && result?.data > 0) {
              ElMessage({
                message: t('user.editSuccessMessage'),
                type: 'success',
                duration: 2000
              })
            } else {
              ElMessage({
                message: result?.msg,
                type: 'error',
                duration: 2000
              })
            }
          }
        })
      },
      async handleUpdatePassword(row: any) {
        dataMap.dialogStatus = 'updatePassword'
        dataMap.dialogFormVisible = true

        await nextTick(() => {
          (dataForm.value as typeof ElForm).resetFields()
        })
        dataMap.tempUserModel.userId = row.userId
      },
      updatePassword() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const userUpdatePassword: UserUpdatePasswordModel = {
              newUserPassword: dataMap.tempUserModel.userPassword
            }
            const result = await updateUserPassword(dataMap.tempUserModel.userId, userUpdatePassword)
            dataMap.dialogFormVisible = false
            dataMap.getList()
            if (result?.data && result?.data > 0) {
              ElMessage({
                message: t('user.editSuccessMessage'),
                type: 'success',
                duration: 2000
              })
            } else {
              ElMessage({
                message: result?.msg,
                type: 'error',
                duration: 2000
              })
            }
          }
        })
      },
      handleDelete(userId: number) {
        ElMessageBox.confirm(t('user.deleteTipMessage'), t('message.tip'), {
          confirmButtonText: t('message.confirm'),
          cancelButtonText: t('message.cancel'),
          type: 'warning'
        }).then(async() => {
          await dataMap.deleteData(userId)
        }).catch(() => {
          ElMessage({
            type: 'info',
            message: t('user.cancelDeleteMessage'),
            duration: 2000
          })
        })
      },
      async deleteData(userId: number) {
        const result = await deleteUser(userId)
        dataMap.getList()
        if (result?.data && result?.data > 0) {
          ElMessage({
            message: t('user.deleteMessage'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.msg,
            type: 'error',
            duration: 2000
          })
        }
      },
      async handleInitializePassword(row: any) {
        ElMessageBox.confirm(t('user.confirmChangePasswordMessage'), t('message.tip'), {
          confirmButtonText: t('message.confirm'),
          cancelButtonText: t('message.cancel'),
          type: 'warning'
        }).then(async() => {
          await dataMap.onInitializePassword(row.userId)
        }).catch(() => {
          ElMessage({
            type: 'info',
            message: t('user.cancelPasswordInitializedMessage'),
            duration: 2000
          })
        })
      },
      async onInitializePassword(userId: number) {
        const result = await initializePassword(userId)
        dataMap.getList()
        if (result?.data && result?.data > 0) {
          ElMessage({
            message: t('user.passwordInitializedMessage'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.msg,
            type: 'error',
            duration: 2000
          })
        }
      },
      resetForm() {
        console.log('reset')
      }
    })
    const validatePassConfirm = (rule: any, value: any, callback: any) => {
      if (value !== dataMap.tempUserModel.userPassword) {
        callback(new Error(t('form.passwordNotMatch')))
      } else {
        callback()
      }
    }
    const rules = {
      userName: [
        { required: true, message: t('dommonData.name').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      userRoleNames: [
        { required: true, message: t('user.roleNames').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      userAccount: [
        { required: true, message: t('user.account').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      userPassword: [
        { required: true, message: t('user.password').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      passwordConfirm: [
        { required: true, message: t('user.passwordConfirm').concat(t('form.isRequired')), trigger: 'blur' },
        { validator: validatePassConfirm, trigger: 'blur' }
      ],
      mailAddress: [
        { required: true, message: t('user.mailAddress').concat(t('form.isRequired')), trigger: 'blur' }
      ],
      department: [
        { required: true, message: t('user.department').concat(t('form.isRequired')), trigger: 'blur' }
      ]
    }
    onMounted(() => {
      dataMap.getRoleName()
      dataMap.getList(null, 20)
    })
    return {
      t,
      ...toRefs(dataMap),
      dataForm,
      rules
    }
  }
})
